var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#546A7E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_4890)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.384 22.7789C18.706 23.0069 19.121 23.0639 19.491 22.9239C19.861 22.7829 20.133 22.4669 20.215 22.0839C21.084 17.9999 23.192 7.6629 23.983 3.9479C24.043 3.6679 23.943 3.3769 23.723 3.1899C23.503 3.0029 23.198 2.9489 22.926 3.0499C18.733 4.6019 5.82003 9.4469 0.542032 11.3999C0.207032 11.5239 -0.0109684 11.8459 3.16428e-05 12.1989C0.0120316 12.5529 0.250032 12.8599 0.593032 12.9629C2.96003 13.6709 6.06703 14.6559 6.06703 14.6559C6.06703 14.6559 7.51903 19.0409 8.27603 21.2709C8.37103 21.5509 8.59003 21.7709 8.87903 21.8469C9.16703 21.9219 9.47503 21.8429 9.69003 21.6399C10.906 20.4919 12.786 18.7169 12.786 18.7169C12.786 18.7169 16.358 21.3359 18.384 22.7789ZM7.37403 14.1019L9.05303 19.6399L9.42603 16.1329C9.42603 16.1329 15.913 10.2819 19.611 6.9469C19.719 6.8489 19.734 6.6849 19.644 6.5699C19.555 6.4549 19.391 6.4279 19.268 6.5059C14.982 9.2429 7.37403 14.1019 7.37403 14.1019Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_4890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a1f37905422674c95c85d7ed54a12554.svg";
export { ForwardRef as ReactComponent };